import { useLocation } from 'react-router-dom';
import locations from './locations.json';

export const sharedPaths = ['/autorepairs', '/towingservice', '/tires', '/stateinspection', '/about', '/contact', '/bgproducts', '/napa', '/terms', '/privacy-policy'];
export function locationRoute(pathname) {
    const normalized = pathname.toLowerCase().replace(/\/+$/, '') || '/';
    const shop = locations.find(entry => normalized === `/${entry.id}` || normalized.startsWith(`/${entry.id}/`));
    const page = shop ? normalized.slice(shop.id.length + 1) || '/' : normalized;
    const to = path => shop ? `/${shop.id}${path === '/' ? '' : path}` : path;
    // Shared content keeps one canonical URL; each shop and contact page is distinct.
    const canonicalPath = shop && sharedPaths.includes(page) && page !== '/contact' ? page : normalized;
    return { shop, page, to, canonicalPath };
}
export function useLocationRoute() { return locationRoute(useLocation().pathname); }
